import type { IconSvgObject } from './types';

const DoorClosedIcon: IconSvgObject = [
  ["path", { d: "M3 21.002H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 21.002V9.00195C5 6.17353 5 4.75931 5.87868 3.88063C6.75736 3.00195 8.17157 3.00195 11 3.00195H13C15.8284 3.00195 17.2426 3.00195 18.1213 3.88063C19 4.75931 19 6.17353 19 9.00195V21.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 12.002H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DoorClosedIcon;
